import React from 'react';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useState } from 'react';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';
const useStyles = makeStyles((theme) => ({
  root: {},
  submitButtonWarranty: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function UrunSatisBilgileri({ FisNo, loading }) {
  const classes = useStyles();

  const [UrunData, setUrunData] = useState([]);


  const UrunBilgileriGetir = () => {

    axios.get('/GetArtemisKeaSatisBilgisi/' + FisNo).then((response) => {
      const PaperCC = response.data;

      setUrunData(PaperCC);

    }).catch(error => {
logger.error("Hata detayı:", error.message);
    });

  }

  if (UrunData.length > 0) {


    loading = false;

  }
  else {

    UrunBilgileriGetir();
  }

  return (
    <Grid container spacing={2}>
      {loading ?
        <CircularProgress
          status={'loading'}
          style={{ marginLeft: '50%' }}
        />
        :
        <Grid item xs={12}>
          {
            UrunData.map(Data => <div>
              <Typography className={classes.title} color="textSecondary" gutterBottom>
                Bayi Kodu
              </Typography>
              <Typography variant="h6" component="h2">
                {Data.BAYI_KODU}
              </Typography>
              <br />
              <Typography className={classes.title} color="textSecondary" gutterBottom>
                Ünvan
              </Typography>
              <Typography variant="h6" component="h2">
                {Data.UNVAN}
              </Typography>
              <br />
              <Typography className={classes.title} color="textSecondary" gutterBottom>
                Satış Tarihi
              </Typography>
              <Typography variant="h6" component="h2">
                {Data.SATIS_TARIHI}
              </Typography>
              <br />
              <Typography className={classes.title} color="textSecondary" gutterBottom>
                Barkod
              </Typography>
              <Typography variant="h6" component="h2">
                {Data.Barkod}
              </Typography>
            </div>
            )
          }
        </Grid>
      }
    </Grid>
  );

}

UrunSatisBilgileri.defaultProps = {
  open: false,
  onClose: () => { }
};


export default UrunSatisBilgileri;
